import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentPageTitle: '',
  downloadReportTitle: '',
  currentLeadID: '',

};

const pageSlice = createSlice({
  name: 'page',
  initialState,
  reducers: {
    setCurrentPageTitle: (state, action) => {
      state.currentPageTitle = action.payload;
    },
    setDownloadReportTitle: (state, action) => {
      state.downloadReportTitle = action.payload;
    },
    resetCurrentPageTitle: (state) => {
      state.currentPageTitle = '';
    },

    setcurrentLeadID: (state, action) => {
      state.currentLeadID = action.payload;
    },
    
    resetcurrentLeadID: (state) => {
      state.currentLeadID = '';
    },
    
  },
});

export const { setcurrentLeadID, setCurrentPageTitle, resetCurrentPageTitle,setDownloadReportTitle,resetcurrentLeadID } = pageSlice.actions;
export default pageSlice.reducer;
